import { createMixin } from '../../../utils'

import { ConnectwareError } from '../../../domain'

import type { DeviationFetcher, DeviationsSubscription, RSTAdapter, StatusTypeFetcher, StatusTypeSubscription } from '.'

const fetchCached = <T>(retrieveCached: () => T | ConnectwareError | null, fetchData: () => Promise<T>): Promise<T> => {
    const value = retrieveCached() ?? fetchData()
    return ConnectwareError.is(value) ? Promise.reject(value) : Promise.resolve(value)
}

export const createRSTAdapter = (
    statusTypeFetcher: StatusTypeFetcher,
    deviationFetcher: DeviationFetcher,
    statusTypeSubscription: StatusTypeSubscription,
    deviationsSubscription: DeviationsSubscription
): RSTAdapter =>
    createMixin<RSTAdapter>({
        fetchServiceDeviationsCount: (...args) =>
            fetchCached(
                () => deviationsSubscription.useCachedServiceDeviationsCount(...args),
                () => deviationFetcher.fetchServiceDeviationsCount(...args)
            ),
        subscribeToServiceDeviationsCount: deviationsSubscription,
        subscribeToServicesDeviationsCount: deviationsSubscription,
        subscribeToResolvedDeviations: deviationsSubscription,
        fetchStatusType: (...args) =>
            fetchCached(
                () => statusTypeSubscription.useCachedStatusType(...args),
                () => statusTypeFetcher.fetchStatusType(...args)
            ),
        subscribeToStatusType: statusTypeSubscription,
    })
